function maskString(
  inputString,
  maskCharacter = "*",
  start = 0,
  end = inputString.length,
) {
  if (start < 0) start = 0;
  if (end > inputString.length) end = inputString.length;

  const maskLength = end - start;
  const mask = maskCharacter.repeat(maskLength);

  const maskedString =
    inputString.substring(0, start) + mask + inputString.substring(end);

  return maskedString;
}

export default maskString;
